import Button from "@mui/material/Button";

export const getColumns = (
  localized,
  handleClickOpenUpdate,
  handleClickOpenDelete
) => [
  {
    field: "countryCode",
    headerName: localized.DomesticCountriesCountryCode,
    headerAlign: "left",
    flex: 1,
  },
  {
    field: "displayName",
    headerName: localized.DomesticCountriesDisplayName,
    headerAlign: "left",
    flex: 1.5,
  },
  {
    field: "updateButton",
    headerName: localized.Update,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <strong>
          <Button
            variant="standard"
            color="update"
            style={{ marginLeft: 16 }}
            onClick={(e) => handleClickOpenUpdate(e, params.row)}
          >
            {localized.Update}
          </Button>
        </strong>
      );
    },
    disableClickEventBubbling: true,
  },
  {
    field: "deleteButton",
    headerAlign: "center",
    align: "center",
    headerName: localized.Delete,
    renderCell: (params) => {
      return (
        <strong>
          <Button
            variant="standard"
            color="error"
            style={{ marginLeft: 16 }}
            onClick={(e) => handleClickOpenDelete(e, params.row)}
          >
            {localized.Delete}
          </Button>
        </strong>
      );
    },
    disableClickEventBubbling: true,
  },
];
